const roleIds = {
  salesHead: [
    "6780c49a0103dd208a38658d",
    "6780c6bf0103dd208a38658f",
    "6780c7660103dd208a386591",
    "6780c9910103dd208a386593",
    "68c7b02d0f5d4d33dbea8e7b",
    "6870aa6108eeac4e84c168e0",
  ],
  admin: ["6799c6552fbc2c922a8a6b8d", "6a2bff700ccb5c0b3bafa728"],
  chinaManager: ["6992cf5be05da0245182eeab", "699b5c4ff1e9bc6d5ec501f0"],
  logist: ["6780f0e0b564652fcaf31615"],
  product: [
    "694a7476846f8003af7cb292",
    "6780eaabb564652fcaf31611",
    "691bfc7f131f652b3072105c",
    "6a0375bc2a06f5741e54f7bb", // Head of Product
  ],
  umit: ["694a7476846f8003af7cb292"],
  accountant: ["6780c1850103dd208a386589"],
  customs: ["6a55c4eb6c992a1a6a0b280b", "6a66eeee9059046eddad76f1"],
  // Руководитель таможенного отдела — вторая группа из customs
  customsHead: ["6a3ba3a07e066430d44c00a1", "6a3ba30fc629341a24cbba13"],
  // Начальник продактов — та же группа остаётся и в product
  productHead: ["6a0375bc2a06f5741e54f7bb"],
};

// Подстраховка к id: на разных стендах у одной и той же группы разные id,
// поэтому роль дополнительно определяется по названию группы или отдела
// пользователя. Матчим вхождение, регистр не важен.
export const roleNamePatterns = {
  customs: [/тамож/i, /customs/i],
};

export default roleIds;
